import * as React from 'react';
import { UIText2, ArticleHeading4, Button } from '@cian/ui-kit';

import { Stars } from '../packages/Stars';
import { getNoun } from '../../utils/getNoun';
import { SuperAgentLabel } from '../SuperAgent';

import * as styles from './styles.css';

export interface IRealtorCardProps {
  previewImg: React.ReactNode;
  timeOnSite: string | undefined | null;
  agencyName: string | undefined | null;
  agentId: number;
  hasRgrParticipation: boolean;
  name?: string | null;
  rate?: number | null;
  reviewsCount?: number | null;
  onClick(): void;
  isSuperAgent?: boolean;
  selectRealtor: () => void;
  unselectRealtor: () => void;
  isSelected: boolean;
  disabledButton: boolean;
}

export function RealtorCard({
  previewImg,
  timeOnSite,
  agencyName,
  agentId,
  name,
  rate,
  reviewsCount,
  onClick,
  selectRealtor,
  unselectRealtor,
  isSelected,
  disabledButton,
  isSuperAgent,
}: IRealtorCardProps) {
  const reviewsCountText = reviewsCount
    ? `${reviewsCount} ${getNoun(reviewsCount, ['отзыв', 'отзыва', 'отзывов'])}`
    : 'Нет отзывов';

  const onSelectRealtorClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (isSelected) {
      unselectRealtor();
    } else {
      selectRealtor();
    }
  };

  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['one-column']}>
        <div className={styles['img']}>{previewImg}</div>
        <div className={styles['text-info']}>
          <div>
            <div className={styles['name']}>
              <span>{name}</span>
            </div>
            {isSuperAgent && (
              <div className={styles['label']}>
                <SuperAgentLabel />
              </div>
            )}
          </div>
          <div>
            <UIText2 color="text-secondary-default">{agencyName}</UIText2>
          </div>
          <div>
            <UIText2 color="text-secondary-default">{timeOnSite}</UIText2>
          </div>
        </div>
      </div>
      <div className={styles['two-column']}>
        <div className={styles['left']}>
          {rate && (
            <div className={styles['rating']}>
              <ArticleHeading4>{(rate * 5).toFixed(2)}</ArticleHeading4>
              <div className={styles['stars']}>
                <Stars uniqueKey={`${agentId}`} value={rate} />
              </div>
            </div>
          )}
          <div className={styles['reviews']}>
            <UIText2 color="text-secondary-default">{reviewsCountText}</UIText2>
          </div>
        </div>
        <div className={styles['right']}>
          <Button
            onClick={onSelectRealtorClick}
            theme={isSelected ? 'fill_white_primary' : 'fill_secondary'}
            disabled={disabledButton && !isSelected}
            size="XS"
          >
            {isSelected ? 'Отменить выбор' : 'Выбрать'}
          </Button>
        </div>
      </div>
    </div>
  );
}
